import React, { useState } from "react";
import { colors } from "../../../../../../themes/Colors";
import { BaseButtons } from "../../../../../common-components";

const ProductCard = ({
  firstName,
  lastName,
  email,
  cellNumber,
  onManageClick,
}) => {
  const [hover, setHover] = useState(false);
  return (
    <div
      onMouseOver={() => setHover(true)}
      onMouseOut={() => setHover(false)}
      style={{
        height: "100%",
        width: "100%",
        display: "flex",
        flexDirection: "row",
      }}
    >
      <div
        style={{
          flex: 1,
          backgroundColor: hover ? colors.greenLight : null,
          // borderRadius: 10,
          //WebkitBoxShadow: hover ? "-5px 5px 15px -1px #00000070" : null,
          transition: "all 0.7s",
          position: "relative",
          display: "flex",
          flexDirection: "row",
          justifyContent: "center",
          alignContent: "center",
          width: "100%",
        }}
      >
        <div
          style={{
            transition: "all 0.5s",
            flex: 0.05,
          }}
        >
          <img
            alt="icon"
            src={
              hover
                ? require("../../../../../../images/icons/profileWhite.png")
                : require("../../../../../../images/icons/profileDarkBlue.png")
            }
            style={{ height: "90%", marginLeft: 5 }}
          />
        </div>
        <div
          style={{
            flex: 0.2,
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <div
            style={{
              width: "100%",
              textAlign: "left",
              fontSize: 14,
              fontWeight: "bolder",
              // marginTop: 80,
              color: hover ? colors.white : colors.secondaryDarkBlue,
              transition: "all 0.25s",
              marginLeft: 10,
            }}
          >
            {firstName}
          </div>
        </div>
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            flex: 0.2,
          }}
        >
          <div
            style={{
              textAlign: "left",
              fontSize: 12,
              // marginTop: 10,
              color: hover ? colors.white : colors.secondaryDarkBlue,
              transition: "all 0.25s",
              fontWeight: "bold",
              width: "100%",
            }}
          >
            {lastName}
          </div>
        </div>
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            flex: 0.25,
          }}
        >
          <div
            style={{
              textAlign: "left",
              fontSize: 12,
              // marginTop: 10,
              color: hover ? colors.white : colors.secondaryDarkBlue,
              transition: "all 0.25s",
              fontWeight: "bold",
              width: "100%",
            }}
          >
            {email}
          </div>
        </div>
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            flex: 0.2,
          }}
        >
          <div
            style={{
              textAlign: "left",
              fontSize: 12,
              // marginTop: 10,
              color: hover ? colors.white : colors.secondaryDarkBlue,
              transition: "all 0.25s",
              fontWeight: "bold",
              width: "100%",
            }}
          >
            {cellNumber}
          </div>
        </div>

        <div
          style={{
            flex: 0.1,
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            // marginTop: 20,
          }}
        >
          <BaseButtons
            label={"MANAGE"}
            color={hover ? colors.secondaryDarkBlue : colors.white}
            backgroundColor={hover ? colors.white : colors.greenDark}
            borderRadius={5}
            width={80}
            onClick={onManageClick ? onManageClick : null}
            height={30}
          />
        </div>
      </div>
    </div>
  );
};

export default ProductCard;
